import { reactive } from "@vue/composition-api";
import { apiEndpoint } from "@/configs/api/api-configs";

export function fufillmentDetailModel() {
  const getFulfillmentDetail = reactive({
    api: `${apiEndpoint.bcrm_platform}/Fulfillment/Detail`,
    method: "POST",
    xRequest: "",
    payload: {
      Ticket_Id: 1,
    },
  });

  const editFulfillmentDetail = reactive({
    api: `${apiEndpoint.bcrm_platform}/Fulfillment/Edit`,
    method: "POST",
    xRequest: "",
    payload: {
      // tracking
      Ticket_Id: 1,
      Status: 1,
      TrackingNo: null,
      Shipping_Company: "Kerry",
      ShippingId: null,
      Shipping_TrackingUrl: null,
      FFM_Detail: "any detail",

      //address
      Title: "นาย",
      First_Name: "Wigi",
      Last_Name: "Pedu",
      Lang_Code: "",
      Address:
        "Vestibulum netus scelerisque mattis, maecenas rhoncus. Senectus eros elit felis tempus augue nulla ligula convallis per. Porta blandit tincidunt torquent arcu eros ut vitae litora. Ut, ipsum dapibus litora lectus non magnis! Blandit accumsan sapien, sit est rhoncus nascetur litora diam netus libero metus neque. Nulla tellus laoreet lorem commodo elit mollis porttitor interdum gravida justo dapibus5",
      HouseNo: null,
      VillageNo: null,
      Lane: null,
      Building: null,
      Street: null,
      SubDistrictId: 1764010033001,
      SubDistrict: "แขวงคลองเตย",
      DistrictId: 1764010033,
      District: "เขตคลองเตย",
      ProvinceId: 1764010,
      Province: "กรุงเทพมหานคร",
      CountryId: 1764,
      Country: "ประเทศไทย",
      PostalCode: "10110",
      Addr_Remark: "null",
      ContactNo: "09111111111",
      Extra_Ref: null,
      Extra_Ref_2: null,
    },
  });

  const fetchTableFulfillmentList = reactive({
    api: `${apiEndpoint.bcrm_platform}/Fulfillment/Privilege_List`,
    method: "POST",
    payload: {
      Page: 1,
      Limit: 10,
      Filters: [
        {
          Seq: 1,
          Key: "query",
          Value: "",
        },
        {
          Seq: 2,
          Key: "shipping_status",
          Value: "1", // Not_Specified = 0 | Pending = 1 | Preparing = 2 | Packed = 5 | Shipped = 7 | Received = 9 | Void = 91
        },
        {
          Seq: 3,
          Key: "privilege_type",
          Value: "1",
        },
      ],
      Ordering: [
        {
          Seq: 1,
          Key: "created_dt",
          Direction: "desc",
        },
      ],
    },
  });

  const fetchTableFulfillmentImportTrackingNoDetail = reactive({
    api: `${apiEndpoint.bcrm_platform}/Fulfillment/Import_TrackingNo_Transacton_Detail`,
    method: "POST",
    payload: {
      ImportId: null,
      Page: 1,
      Limit: 10,
      Filters: [],
      Ordering: [] 
    },
  });

  const fetchTableFulfillmentImportTrackingNoList = reactive({
    api: `${apiEndpoint.bcrm_platform}/Fulfillment/Import_TrackingNo_List`,
    method: "POST",
    payload: {
      Page: 1,
      Limit: 10,
      Filters: [],
      Ordering: [] 
    },
  });

  return {
    getFulfillmentDetail,
    editFulfillmentDetail,
    fetchTableFulfillmentList,
    fetchTableFulfillmentImportTrackingNoDetail,
    fetchTableFulfillmentImportTrackingNoList
  };
}
